import React from 'react'
import { LocationBuilding } from '../common/Location'
import { Link } from 'react-router-dom'
import { formatUrl } from '../../util/formatUtils'
import { locationRoute } from '../../routes/routes'

const SelectLocation = ({ locations, address, buildingName }) => {
  return (
    <div className="row center-xs">
      <div className="col-xs-12">
        <h1 className="title">Please select your company</h1>
        <div className="location">
          <div className="location-content location-content_search">
            <LocationBuilding
              address={address}
              name={buildingName}
              style={{ justifyContent: 'center' }}
            />
          </div>
          <div className="row start">
            <div className="col-xs start-xs">
              <strong>Existing offices</strong>
            </div>
          </div>
          <table className="location-table">
            <thead>
              <tr>
                <th />
                <th />
              </tr>
            </thead>
            <tbody>
              {locations.map(function(dropoff) {
                return (
                  <tr key={dropoff.id}>
                    <td>{dropoff.name}</td>
                    <td>
                      <Link
                        className="button primary location-table_select"
                        to={formatUrl(locationRoute.path, {
                          locationId: dropoff.id
                        })}
                      >
                        Order Now
                      </Link>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default SelectLocation
